export function sortArrayByReference( arrToSort, referenceArray ) {
	// Create a Map for efficient lookup of element positions in the reference array
	const orderMap = new Map();

	referenceArray.forEach( ( item, index ) => {
		orderMap.set( item, index );
	} );

	// Sort the array
	arrToSort.sort( ( a, b ) => {
		const indexA = orderMap.has( a ) ? orderMap.get( a ) : Infinity; // Assign Infinity for elements not in referenceOrder
		const indexB = orderMap.has( b ) ? orderMap.get( b ) : Infinity;

		// Compare based on the assigned indices
		if ( indexA < indexB ) {
			return -1; // a comes before b
		} else if ( indexA > indexB ) {
			return 1; // b comes before a
		}

		// If indices are the same (e.g., both not in referenceOrder or same value), maintain original relative order or apply a secondary sort
		return 0;
	} );

	return arrToSort;
}
